import { render, staticRenderFns } from "./PageResellers.vue?vue&type=template&id=087e4ac2"
import script from "./PageResellers.vue?vue&type=script&lang=js"
export * from "./PageResellers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports